/**
 * @flow
 * @relayHash 2a349e4a8304e75b8ccac0d5f61aee71
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendInvitationToContractorInput = {|
  id: string,
  message?: ?string,
  clientMutationId?: ?string,
|};
export type SendInvitationToContractorMutationVariables = {|
  input: SendInvitationToContractorInput
|};
export type SendInvitationToContractorMutationResponse = {|
  +sendInvitationToContractor: ?{|
    +emailSent: ?boolean,
    +updatedContractor: ?{|
      +invitationEmailSent: ?any
    |},
  |}
|};
export type SendInvitationToContractorMutation = {|
  variables: SendInvitationToContractorMutationVariables,
  response: SendInvitationToContractorMutationResponse,
|};
*/


/*
mutation SendInvitationToContractorMutation(
  $input: SendInvitationToContractorInput!
) {
  sendInvitationToContractor(input: $input) {
    emailSent
    updatedContractor {
      invitationEmailSent
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendInvitationToContractorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailSent",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "invitationEmailSent",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendInvitationToContractorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sendInvitationToContractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SendInvitationToContractorPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedContractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SendInvitationToContractorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sendInvitationToContractor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SendInvitationToContractorPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedContractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendInvitationToContractorMutation",
    "id": null,
    "text": "mutation SendInvitationToContractorMutation(\n  $input: SendInvitationToContractorInput!\n) {\n  sendInvitationToContractor(input: $input) {\n    emailSent\n    updatedContractor {\n      invitationEmailSent\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71cf52dd7a3e477b9bda892547688b0a';
module.exports = node;
